import { Block, Text } from '@snowflake/core-ui';
import * as React from 'react';
import { InfoList } from './InfoList';
import { CortexInstallBlock } from './CortexInstallBlock';
import { CortexFinePrint } from './CortexFinePrint';
import { SubtitleHeading } from './SubtitleHeading';
import { useSignupPageContext } from '../../pages/SignupContext';

export const CortexLeftContent = () => {
  const { renderingOptions } = useSignupPageContext();
  return (
    <Block
      className="trial-left-container"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <SubtitleHeading />
      <InfoList />
      <Block marginTop="-12px">
        <Text
          weight="semi-bold"
          style={{ color: '#29B5E8', fontSize: '20px', lineHeight: '30px' }}
          marginBottom="28px"
        >
          {renderingOptions.cardMarketingTitle}
        </Text>
        <CortexInstallBlock />
      </Block>
      <CortexFinePrint />
    </Block>
  );
};
